import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "";

const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    // Automatically refresh token when it expires
    autoRefreshToken: true,
    // Persist session in local storage
    persistSession: true,
    // Detect session from URL (for OAuth flows)
    detectSessionInUrl: true,
    // Storage key for session
    storageKey: "fibbovoice-auth",
    // Flow type for authentication
    flowType: "pkce", // More secure than implicit flow
  },
});

export default supabase;
